import { XNumberField } from '@ioip/core/lib';
import React from 'react';
import CTextField from '../types/CTextField';
import { IPFieldProps } from '../../types/field-props';

export const UXNumberField = (props: IPFieldProps<CTextField>): JSX.Element => {

    const field = props.field;
    const label = field.label;
    const placeholder = field.placeholder;
    const disabled = field.readonly || field.disabled;
    const required = field.required;
    const multiline = field.multiline;
    const maxLength = field.maxLength;
    const value = field.value as any;

    return <XNumberField
        label={label || ''}
        placeholder={placeholder || ''}
        onChanged={(e: any) => field.value = e}
        required={required}
        disabled={disabled || false}
        readonly={disabled}
        multiline={multiline || false}
        maxLength={maxLength > 0 ? maxLength : null}
        value={value}
        errorMessage={props.field.errorMessage || ''}
    />
}